import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { TitleSharp } from "@mui/icons-material";
import AdminLayout from "../../../layout/AdminLayout";
import { colors } from "../../../theme/theme";
import { CustomInput } from "../../../components/Common/CustomInput";
import { CustomBtn } from "../../../components/Common/CustomBtn";
import ImageUploadInput from "../../../components/Common/ImageUploadInput";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import { getAboutMe } from "../../../redux/dispatchers/aboutMe.dispatcher";
import axiosInstance from "../../../utils/config/config";

const AdminAboutMe = () => {
  const dispatch = useDispatch();
  const { aboutMe } = useSelector((state) => state.aboutMe);

  const [name, setName] = useState("");
  const [tagline, setTagline] = useState("");
  const [bio, setBio] = useState("");
  const [photo, setPhoto] = useState(null);
  const [cover, setCover] = useState(null);
  const [success, setSuccess] = useState(false);
  const [errorState, setErrorState] = useState({ error: false, errorMsg: "" });

  useEffect(() => {
    dispatch(getAboutMe());
  }, [dispatch]);

  useEffect(() => {
    if (aboutMe) {
      setName(aboutMe.name || "");
      setTagline(aboutMe.tagline || "");
      setBio(aboutMe.bio || "");
      setPhoto(aboutMe.photo_url || null);
      setCover(aboutMe.cover_url || null);
    }
  }, [aboutMe]);

  const handleSave = async () => {
    try {
      await axiosInstance.put("/aboutMe/update", {
        name,
        tagline,
        bio,
        photo_url: photo,
        cover_url: cover,
      });
      setSuccess(true);
      dispatch(getAboutMe());
    } catch (error) {
      setErrorState({
        error: true,
        errorMsg: error?.response?.data?.message || "Failed to update About Me",
      });
    }
  };

  return (
    <AdminLayout heading="About Me">
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, errorMsg: "" })}
        errorMsg={errorState.errorMsg}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text="About Me Updated Successfully"
      />

      <Grid container spacing={4}>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <ImageUploadInput
            image={cover}
            setImage={setCover}
            width={"90%"}
            height={"260px"}
            label={"Cover Photo"}
            labelColor={"#fff"}
          />
        </Grid>

        <Grid item size={{ xs: 12, sm: 6 }}>
          <ImageUploadInput
            image={photo}
            setImage={setPhoto}
            width={"90%"}
            height={"260px"}
            label={"Profile Photo"}
            labelColor={"#fff"}
          />
        </Grid>
      </Grid>

      <Grid container spacing={4} sx={{ mt: 1 }}>
        <Grid item size={{ xs: 12, md: 6 }}>
          <CustomInput
            label={"Name"}
            value={name}
            handleChange={(e) => setName(e.target.value)}
            placeholder={"Enter name"}
            Icon={TitleSharp}
            width={"100%"}
            color={"#fff"}
            borderColor={colors.secondary}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <CustomInput
            label={"Tagline"}
            value={tagline}
            handleChange={(e) => setTagline(e.target.value)}
            placeholder={"Enter tagline"}
            noIcon
            width={"100%"}
            color={"#fff"}
            borderColor={colors.secondary}
          />
        </Grid>
        <Grid item size={{ xs: 12 }}>
          <CustomInput
            label={"Text"}
            value={bio}
            handleChange={(e) => setBio(e.target.value)}
            placeholder={"Enter bio text"}
            noIcon
            width={"100%"}
            color={"#fff"}
            borderColor={colors.secondary}
            textArea
          />
        </Grid>
      </Grid>

      <CustomBtn text={"Save"} width={"200px"} mt={3} onClick={handleSave} />
    </AdminLayout>
  );
};

export default AdminAboutMe;
